<template>
  <div>
    <FetchingOverlay v-if="isLoading" />
    <p>Order Summary</p>
    <div class="schedule">
      <template v-if="orders.length">
        <SchedulesItem
          v-for="(order, index) of orders"
          :key="index"
          :index="index"
          :order="order"
          @onEditSchedule="onEditSchedule"
        />
        <SchedulesTotal :total="total" />
      </template>

      <Schedule class="schedule__item" v-else />
      <div class="schedule__shadow"></div>
      <CheckoutButton
        @fetching="handleLoading"
        :user="user"
        class="btn--checkout"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Schedule from "@/components/placeholder/Schedule";
import SchedulesItem from "@/components/booking/SchedulesItem";
import SchedulesTotal from "@/components/booking/SchedulesTotal";
import CheckoutButton from "@/components/booking/CheckoutButton";
import FetchingOverlay from "@/components/FetchingOverlay";

export default {
  components: {
    Schedule,
    SchedulesItem,
    SchedulesTotal,
    CheckoutButton,
    FetchingOverlay
  },
  data: () => ({
    isLoading: false,
    orderData: null,
    orderIndex: null
  }),
  props: {
    orders: {
      type: [Array],
      default: null
    },
    user: {
      type: [Object],
      default: null
    }
  },
  computed: {
    total() {
      return this.getOrders()
        .map(order => order.OrderPackage.total)
        .reduce((accumulator, num) => accumulator + num)
        .toLocaleString("en-US", { minimumFractionDigits: 2 });
    }
  },
  methods: {
    ...mapActions({
      ORDER_ADD_SCHEDULE: "ORDER_ADD_SCHEDULE",
      ORDER_REMOVE_SCHEDULE: "ORDER_REMOVE_SCHEDULE",
      ORDER_CLEAR: "ORDER_CLEAR",
      ORDER_SET_BY_INDEX: "ORDER_SET_BY_INDEX"
    }),
    ...mapGetters({
      getOrders: "getOrders"
    }),
    handleLoading(isLoading) {
      this.isLoading = isLoading;
    },
    onEditSchedule(content) {
      this.$emit("onEdit", content);
    }
  }
};
</script>

<style lang="scss" scoped>
@media (min-width: 768px) {
  .schedule {
    height: 355px;
    overflow-y: auto;
    overflow-x: hidden;
    &__shadow {
      background-image: linear-gradient(rgba(255, 255, 255, 0.5), white);
      box-shadow: 0 -15px 45px 15px rgba(255, 255, 255, 0.5);
      content: "";
      height: 50px;
      pointer-events: none;
      position: absolute;
      top: 450px;
      left: 45px;
      width: calc(100% - 90px);
    }
  }
}
.schedule {
  &__shadow {
    display: none;
  }
}

.btn--checkout {
  display: block;
  margin-left: auto;
  margin-top: 20px;
}
</style>
